module.exports = __webpack_public_path__ + "img/Vault Icon.d4f513f8.svg";